import _ from 'underscore';
import rowHeaders from './row_headers';
import getColumn from './column';
import getSubColumn from './sub_column';
import { getCell } from './cell';
import Time from '../../lib/time';

const addData = (table, subColumn, cell) => {
	subColumn.rows.push(cell);
	if(!table.subColumns.entities[subColumn.id]) {
		table.subColumns.entities[subColumn.id] = subColumn;
		table.subColumns.items.push(subColumn);
	}
	if(!table.cells.entities[cell.id]) {
		table.cells.entities[cell.id] = cell;
		table.cells.items.push(cell);
	}
};

const createCellData = (table, meeting, props) => {
	let {columnProperty, startTime, endTime} = props;
	let columnName = meeting[columnProperty];
	let column = getColumn(table.columns, columnName, columnProperty);
	let subColumns = _.compact(
		_.map(props.subColumnFilters, subColumnFilter => {
			if(subColumnFilter.filter(meeting)) {
				return getSubColumn(column, subColumnFilter.type, subColumnFilter.name, subColumnFilter.attribute);
			}
		})
	);
	return getCell({
		startTime: startTime,
		endTime: endTime,
		column: column,
		subColumns: subColumns,
		scheduledMeeting: meeting
	});
};

const tableProps = (scheduledMeetings, props) => {
	return {
		rowHeaders: rowHeaders(props, scheduledMeetings),
		columns: {items: [], entities: {}},
		subColumns: {items: [], entities: {}},
		cells: {items: [], entities: {}},
		scheduledMeetings: [].concat(scheduledMeetings)
	};
};

export default function createTableData(props) {
	let scheduledMeetings = _.sortBy(props.scheduledMeetings, scheduledMeeting => {
		return Time.parse(scheduledMeeting.start_time).totalMinutes;
	});

	let tableData = tableProps(scheduledMeetings, props);
	
	scheduledMeetings.forEach(scheduledMeeting => {
		let cellData = createCellData(tableData, scheduledMeeting, props);
		cellData.subColumns.forEach(subColumn => {
			addData(tableData, subColumn, cellData);
		});
	});

	return tableData;
};


/** WEBPACK FOOTER **
 ** ./src/js/lib/schedule_table/create_table_data.js
 **/